(() => {
  const key = 'bp26-theme';
  const root = document.documentElement;
  const preference = () => {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  };
  const sync = () => {
    document.querySelectorAll('[data-bp-mode-toggle]').forEach((button) => {
      const label = root.dataset.bpTheme === 'dark' ? button.dataset.labelLight : button.dataset.labelDark;
      button.setAttribute('aria-label', label);
      button.hidden = false;
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bp-mode-toggle]');
    if (!button) return;
    const next = root.dataset.bpTheme === 'dark' ? 'light' : 'dark';
    root.dataset.bpTheme = next;
    try { localStorage.setItem(key, next); } catch (_) {}
    sync();
  });
  const system = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
  if (system && system.addEventListener) system.addEventListener('change', (event) => {
    if (!['light', 'dark'].includes(preference())) {
      root.dataset.bpTheme = event.matches ? 'dark' : 'light';
      sync();
    }
  });
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
